// 輪詢相關翻譯

export const polling = {
    // Error messages
    queryStatusFailed: 'Failed to query status, please try again later',
    taskNotFound: 'Task not found, may have been deleted',
    authenticationFailed: 'Authentication failed, please log in again',
    serverInternalError: 'Server internal error, please try again later',
    requestTooFrequent: 'Requests too frequent, please try again later',
    networkConnectionFailed: 'Network connection failed, please check your network connection',
    unknownError: 'Unknown error',
    generationFailed: 'Generation failed',
    
    // Status messages
    generationTimeout: 'Generation timeout, please try again',
    
    // Error types
    contentPolicy: 'Content does not comply with platform policy, please modify and try again',
    recitationConcern: 'Content may involve copyright issues, please try modifying the prompt and try again',
    rateLimit: 'Requests too frequent, please try again later',
    credits: 'Insufficient credits, please recharge and try again',
    timeout: 'Generation timeout, please try again',
    noImageGenerated: 'Unable to generate image for this prompt, please try modifying the prompt',
    
    // Toast messages
    generationFailedToast: 'Generation failed'
  };
